import type { ReactNode } from 'react';

// A page-level error line (a failed save, a refused import). role="alert" so a
// screen reader announces it the moment it appears; renders nothing while
// there is no error. The class defaults to the house 12px danger line; callers
// that had their own spacing pass the full class string.
export function FormError({ children, className = 'text-[0.75rem] text-danger' }: { children?: ReactNode; className?: string }) {
  if (children == null || children === false || children === '') return null;
  return <div role="alert" className={className}>{children}</div>;
}
